export default __webpack_public_path__ + "static/media/11.1c8b4748.jpg";